import { http } from './HttpService.js'
import axios from 'axios';


export default {
	load(params = '') {
		return http.get('fiscal' + params)
	},
	loadCfe(params = '') {
		return http.get('fiscal/cfe' + params)
	},
	sum(params = '') {
		return http.get('fiscal/sum' + params)
	},
	sumCfe(params = '') {
		return http.get('fiscal/cfe/sum' + params)
	},
	download(id, idi) {
		return http.get(`cfe/xml/${idi}/${id}`)
	},
	loadInventario(params = '') {
		return http.get('inventario' + params)
	},
	loadNotasCompra(params = '') {
		return http.get('notasCompra' + params);
	},
	loadInventarioPDF(params = '',data) {
		return http.post('relatorioInventario' + params,{produtos:data});
	},
	loadPISCOFINS(params = ''){
		return http.get('relatorioPISCOFINS' + params);
	},
	salvaNota(data) {
	return http.post('salvaNota', data);
	},
	CarregarCompra(data) {
		return http.post('carregaNota', data);
	},
	deletaPorId(codigo) {
		return http.post('apagaNota',codigo);
	},
	produtosVinculado(data) {
		return http.post('vinculaProdutos', data);
	},
	CarregarNota(base64){
		const xmlparser = require('xml2js').parseString;
		try{
			var data = atob(base64).toString()
			if (data.charCodeAt(0) == 239 && data.charCodeAt(1) == 187 && data.charCodeAt(2) == 191) {
				data = data.substr(3);
			}
			xmlparser(data, (err, result) => {
				if(err) {
					return err;
				}
				console.log(result);
				return result;
			});
			return data;
		}catch (ex){
			console.log('XML invalido');
		}
	},
	salvaNota(data) {
		return http.post('salvaNota', data);
	},
	salvaNotaRobo(data) {
		return http.post('salvaNotaRobo', data);
	},
	mail(params = ''){
		return http.get('xml/mail' + params);
	},
	mailCfe(params = ''){
		return http.get('cfe/xml/mail' + params);
	}
	
}
